var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"btn-primary",attrs:{"loading":_vm.submitting},on:{"click":_vm.submitOrder}},[_vm._v(" Finalize and Send ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }